import { t } from "i18next";
import { herobg1 } from "../assets/Images";
import { herobg2 } from "../assets/Images";
import { herobg3 } from "../assets/Images";
import { herobg4 } from "../assets/Images";
import { MdOutlineFoodBank } from "react-icons/md";

import {

  clints,
  victory,
  Hands,
  Experiance,
  IoLogoWhatsapp,
  SiFacebook,

  FaHome,
  FaInfoCircle,
  FaHandsHelping,

  IoIosCreate,
  TbCategoryFilled,
  MdCreateNewFolder,

  IoPieChartSharp,
  FaTelegram,
  FaXTwitter,

} from "../components/utils/icons";
import { FaI } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";

const HeroImages = [
  {
    id: 0,
    img: herobg1,
    titleAr: "أصالة المطبخ اليمني على مائدتك",
    titleEn: "Authentic Yemeni Cuisine at Your Table",
    subTitleAr: `مندي | مظبي | حنيذ | زربيان
لحوم مختارة بعناية ونكهات يمنية غنية
في يمان نقرّب إليك مذاق اليمن الأصيل`,
    subTitleEn: `Mandi | Madhbi | Haneeth | Zurbian
Carefully selected meats with rich Yemeni flavors
At Yaman, we bring you the authentic taste of Yemen.`,
  },

  {
    id: 1,
    img: herobg2,
    titleAr: "نكهات يمنية تستحق التجربة",
    titleEn: "Yemeni Flavors Worth Experiencing",
    subTitleAr: `أطباق دجاج محضرة على الطريقة اليمنية
تتبيلات غنية ونكهات متوازنة في كل طبق
تجربة تجمع بين الأصالة والجودة`,
    subTitleEn: `Chicken dishes prepared the Yemeni way
Rich seasoning and balanced flavors in every dish
An experience where authenticity meets quality.`,
  },

  {
    id: 2,
    img: herobg3,
    titleAr: "من البحر إلى يمان",
    titleEn: "From the Sea to Yaman",
    subTitleAr: `مأكولات بحرية مختارة بعناية
تحضير طازج ولمسات مستوحاة من المطبخ اليمني
نكهات مميزة لعشاق المأكولات البحرية`,
    subTitleEn: `Carefully selected seafood dishes
Freshly prepared with Yemeni-inspired touches
Distinctive flavors crafted for seafood lovers.`,
  },

  {
    id: 3,
    img: herobg4,
    titleAr: "حلاوة يمنية بلمسة يمان",
    titleEn: "Yemeni Desserts, the Yaman Way",
    subTitleAr: `معصوب | عريكة | كنافة | عسل
مذاقات غنية تجمع القشطة والعسل والمكونات المختارة
النهاية المثالية لتجربة يمنية متكاملة`,
    subTitleEn: `Masoob | Areeka | Kunafa | Honey
Rich flavors combining cream, honey and selected ingredients
The perfect ending to an authentic Yemeni dining experience.`,
  },
];

const FotterText = {
  textEn:
    "Yaman Restaurant - An authentic Yemeni dining experience in Egypt, bringing together traditional flavors, carefully selected ingredients, and the rich heritage of Yemeni cuisine. At Yaman, every dish is prepared to offer you a distinctive taste and a memorable dining experience.",

  textAr:
    "مطعم يمان - تجربة يمنية أصيلة في مصر، تجمع بين النكهات التقليدية والمكونات المختارة بعناية وعراقة المطبخ اليمني. في يمان نُعد كل طبق لنقدم لكم مذاقًا مميزًا وتجربة طعام تبقى في الذاكرة.",
};


const navItems = [
  {
    id: 1,
    titleEn: "Home",
    titleAr: "الرئيسية",
    link: "/",
    icon: <FaHome />,
  },
  {
    id: 2,
    titleEn: "About Us",
    titleAr: "من نحن",
    link: "/AboutUs",
    icon: <FaInfoCircle />,
  },
  {
    id: 3,
    titleEn: "all Offers",
    titleAr: " جميع العروض",
    link: "/AllFeaturedMeals",
    icon: <FaHandsHelping />,
  },

  {
    id: 4,
    titleEn: "categories",
    titleAr: "الاصناف",
    link: "/MealsCategories",
    icon: <TbCategoryFilled />,
  },
  {
    id: 5,
    titleEn: "Meals",
    titleAr: "الوجبات",
    link: "/AllResturentMeals",
    icon: <MdOutlineFoodBank />,
  },
];
const countUpData = [
  {
    id: 1,
    titleEn: "Closed Cases",
    titleAr: "قضايا مغلقة",
    count: 201560,
    icon: victory,
  },
  {
    id: 2,
    titleEn: "Clients",
    titleAr: "عملاء",
    count: 300000,
    icon: clints,
  },
  {
    id: 3,
    titleEn: "Years Experience",
    titleAr: "سنوات الخبرة",
    count: 40,
    icon: Experiance,
  },
  {
    id: 4,
    titleEn: "Lawyers",
    titleAr: "محامين",
    count: 15,
    icon: Hands,
  },
];
const socialMedia = [
  {
    id: 1,
    titleAr: "فيسبوك",
    titleEn: "Facebook",
    icon: <SiFacebook />,
    link: "https://www.facebook.com/share/1CTDcZDFan/?mibextid=wwXIfr",
  },
  {
    id: 2,
    titleAr: "إنستجرام",
    titleEn: "Instagram",
    icon: <FaInstagram />,
    link: "https://www.instagram.com/yamanrestaurant?utm_source=qr",
  },
  {
    id: 3,
    titleAr: "واتس أب",
    titleEn: "WhatsApp",
    icon: <IoLogoWhatsapp />,
    link: "https://wa.me/201080608050",
  },

];

const localeTextGrid = {
  columnMenuSortAsc: t('Sort Ascending'), // ترتيب تصاعدي
  columnMenuSortDesc: t('Sort Descending'), // ترتيب تنازلي
  columnMenuUnsort: t('Unsort'), // إلغاء الترتيب
  columnMenuHideColumn: t('Hide Column'), // إخفاء العمود
  columnMenuManageColumns: t('Manage Columns'), // إدارة الأعمدة
  columnsPanelTextFieldLabel: t('Find column'), // البحث عن عمود
  columnsPanelTextFieldPlaceholder: t('Column title'), // عنوان العمود
  columnsPanelShowAllButton: t('Show all'), // عرض الكل
  columnsPanelHideAllButton: t('Hide all'), // إخفاء الكل
  columnsManagementReset: t('Reset'), // إعادة تعيين
  columnsManagementSearchTitle: t('Search'), // ترجمة كلمة "Search"

};


const AdminLinks = [
  {
    title: "Dashboard",
    links: [
      {
        name: "Dashboard",
        icon: <IoPieChartSharp />,
        linkSide: "admin",
      },
    ],
  },
  {
    title: "Meals",
    links: [ 
      {
        name: "Create Category",
        icon: <MdCreateNewFolder />,
        linkSide: "CreateCategoryPage",
      },
      {
        name: "Meal Categories",
        icon: <TbCategoryFilled />,
        linkSide: "DAllCategoriesPage",
      },
      {
        name: "All Meals",
        icon: <MdOutlineFoodBank />,
        linkSide: "DAllMealsPage",
      },
      {
        name: "Create Meal",
        icon: <IoIosCreate />,
        linkSide: "CreateMealPage",
      },
      {
        name: "Offers",
        icon: <MdOutlineFoodBank />,
        linkSide: "DAllFeaturedMealsPage",
      },
      {
        name: "Create Offer",
        icon: <IoIosCreate />,
        linkSide: "CreateFeaturedMealsPage",
      },
    
     
    ],
  },
  {
    title: "Reviews",
    links: [
      {
        name: "All Reviews",
        icon: <FaHandsHelping />,
        linkSide: "DAllReviewsPage",
      },
      {
        name: "Create Review",
        icon: <IoIosCreate />,
        linkSide: "CreateReviewPage",
      },
    ],
  },
];

const DeletButtonStyle={
  color: '#fff',
  background: 'linear-gradient(to right, #dc2626, #b91c1c, #dc2626)',
  boxShadow: '0 4px 6px -1px rgba(220, 38, 38, 0.5), 0 2px 4px -2px rgba(220, 38, 38, 0.5)',
  border: 'none',

  borderRadius:"5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}

const DeleteonMouseEnter= (e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #dc2626, #b91c1c)';
}
const DeleteonMouseLeave=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #dc2626, #b91c1c, #dc2626)';
}
const DeleteonFocus=(e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(185, 28, 28, 0.5)';
}
const DeleteonBlur=(e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(220, 38, 38, 0.5), 0 2px 4px -2px rgba(220, 38, 38, 0.5)';
}
const EditButtonStyle =
{
  color: '#fff',
  backgroundImage: 'linear-gradient(to right, #eab308, #ca8a04, #eab308)',
  boxShadow: '0 4px 6px -1px rgba(234, 179, 8, 0.5), 0 2px 4px -2px rgba(234, 179, 8, 0.5)',
  border: 'none',

 borderRadius:"5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}
const EditonMouseEnter=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #eab308, #ca8a04)';
}
const EditonMouseLeave=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #eab308, #ca8a04, #eab308)';
}
const EditonFocus=(e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(202, 138, 4, 0.5)';
}
const EditonBlur=(e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(234, 179, 8, 0.5), 0 2px 4px -2px rgba(234, 179, 8, 0.5)';
}

const ViewButtonStyle = {
  color: '#fff',
  background: 'linear-gradient(to right, #16a34a, #15803d, #16a34a)',
  boxShadow: '0 4px 6px -1px rgba(22, 163, 74, 0.5), 0 2px 4px -2px rgba(22, 163, 74, 0.5)',
  border: 'none',
  borderRadius: "5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}

const ViewonMouseEnter = (e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #16a34a, #15803d)';
}

const ViewonMouseLeave = (e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #16a34a, #15803d, #16a34a)';
}

const ViewonFocus = (e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(21, 128, 61, 0.5)';
}

const ViewonBlur = (e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(22, 163, 74, 0.5), 0 2px 4px -2px rgba(22, 163, 74, 0.5)';
}

export {
  HeroImages,
  navItems,
  countUpData,
  FotterText,
  socialMedia,


  AdminLinks,
  localeTextGrid,
  DeletButtonStyle,
  DeleteonMouseEnter,
  DeleteonMouseLeave,
  DeleteonFocus,
  DeleteonBlur,
  EditButtonStyle,
  EditonMouseEnter,
  EditonMouseLeave,
  EditonFocus,
  EditonBlur,
  ViewButtonStyle,
  ViewonMouseEnter,
  ViewonMouseLeave,
  ViewonFocus,
  ViewonBlur,

  
};
